<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <template v-if="!invoice.ID && loaded">
      <b-row>
        <b-col lg="12">
          <b-alert show>Facture inexistante</b-alert>
        </b-col>
      </b-row>
    </template>
    <b-row v-if="loaded && invoice.ID" class="mx-0 mb-3">
      <b-col>
        <b-card no-body class>
          <b-tabs card content-class="mt-3">
            <b-tab :title="invoice.type.i18n">
              <b-row>
                <b-col lg="12" class="mb-3">
                  <b-button
                    @click="save()"
                    size="sm"
                    class="mr-3"
                    variant="success"
                    title="Enregistrer"
                    ><b-icon-check-circle-fill></b-icon-check-circle-fill
                  ></b-button>
                  <b-button
                    class="mr-3"
                    size="sm"
                    target="_blank"
                    :href="pdf"
                    title="PDF de la facture"
                    variant="secondary"
                    ><b-icon-printer-fill></b-icon-printer-fill
                  ></b-button>
                  <b-button
                    @click="$bvModal.show('email-invoice')"
                    size="sm"
                    title="Envoyer la facture par mail"
                    ><b-icon-envelope-fill></b-icon-envelope-fill
                  ></b-button>
                </b-col>
                <b-col lg="6">
                  <b-card class="mb-2 bg-light shadow" >
                    <b-row>
                      <mh-input
                        mh-class="col-12"
                        label="Créancier"
                        field="creancierID"
                        :table="invoice"
                        :readonly="invoice.cloture.value == 'yes'"
                        labelColsLg="2"
                      ></mh-input>
                      <mh-input
                        mh-class="col-6"
                        field="date"
                        :table="invoice"
                        readonly
                      ></mh-input>
                      <mh-input
                        mh-class="col-6"
                        field="type"
                        :table="invoice"
                        readonly
                      ></mh-input>
                      <mh-input
                        mh-class="col-6"
                        label="Vendeur"
                        field="vendeurID"
                        :readonly="!edit"
                        :table="invoice"
                      ></mh-input>
                      <mh-input
                        mh-class="col-6"
                        field="vendeur_commission"
                        :readonly="!edit"
                        :table="invoice"
                        append="%"
                      ></mh-input>
                      <mh-input
                        mh-class="col-6"
                        field="comstruct"
                        :table="invoice"
                        readonly
                      ></mh-input>
                      <mh-input
                        mh-class="col-6"
                        field="tva"
                        :readonly="invoice.cloture.value == 'yes'"
                        :table="invoice"
                        append="%"
                      ></mh-input>
                      <mh-input
                        mh-class="col-6"
                        field="cloture"
                        readonly
                        :table="invoice"
                      ></mh-input>
                      <mh-input
                        mh-class="col-6"
                        field="prixHTVA"
                        :readonly="invoice.cloture.value == 'yes'"
                        :table="invoice"
                        append="€"
                      ></mh-input>
                      <mh-input
                        mh-class="col-6"
                        field="prixTVAC"
                        readonly
                        :table="invoice"
                        append="€"
                      ></mh-input>
                      <mh-input
                        mh-class="col-6"
                        field="solde"
                        readonly
                        :table="invoice"
                        append="€"
                      ></mh-input>
                      <mh-input
                        mh-class="col-6"
                        field="reference_societe"
                        :table="invoice"
                        :readonly="invoice.cloture.value == 'yes'"
                      ></mh-input>
                      <mh-input
                        mh-class="col-6"
                        field="reference_client"
                        :readonly="invoice.cloture.value == 'yes'"
                        :table="invoice"
                      ></mh-input>
                      <mh-input
                        mh-class="col-12"
                        field="note"
                        :readonly="!edit"
                        :table="invoice"
                        labelColsLg="2"
                      ></mh-input>
                    </b-row>
                  </b-card>
                </b-col>
                <b-col lg="6">
                  <b-card class="mb-2 shadow bg-light">
                    <b-table
                      hover
                      :fields="invoiceLinesFields"
                      :items="invoice.lignesFacture"
                      small
                    >
                      <template v-slot:cell(description)="data">
                        <span v-html="data.item.description"></span>
                      </template>
                      <template v-slot:cell(prix_unitaire)="data"
                        >{{ twoDigits(data.item.prix_unitaire) }} €</template
                      >
                      <template v-slot:cell(unit)="data">{{
                        data.item.unit
                      }}</template>

                      <template v-slot:cell(soustotal)="data"
                        >{{
                          twoDigits(data.item.prix_unitaire * data.item.unit)
                        }}
                        €</template
                      >
                      <template v-slot:cell(soustotalTVAC)="data"
                        >{{ twoDigits(data.value) }} €</template
                      >
                      <template v-slot:bottom-row>
                        <td />
                        <td />
                        <td />
                        <td>
                          <strong>
                            Total :
                            <span class="float-right"
                              >{{ twoDigits(invoiceLinesTotal) }} €</span
                            >
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <span class="float-right"
                              >{{ twoDigits(invoiceLinesTotalVTAC) }} €</span
                            >
                          </strong>
                        </td>
                      </template>
                    </b-table>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>

            <b-tab
              v-if="invoice.releve_compteID.value != 0"
              title="Relevé de compte"
            >
              <b-row>
                <b-col lg="12">
                  <b-card
                    class="mb-2 shadow bg-light"
                  >
                    <b-row>
                      <b-col lg="12" class="mb-3">
                        <b-button
                          class="mr-3"
                          target="_blank"
                          size="sm"
                          title="PDF du relevé"
                          :href="account_statement_pdf"
                          variant="secondary"
                          ><b-icon-printer-fill></b-icon-printer-fill
                        ></b-button>
                        <b-button size="sm" title="Envoyer par mail"
                          ><b-icon-envelope-fill></b-icon-envelope-fill
                        ></b-button>
                      </b-col>
                    </b-row>

                    <b-row>
                      <mh-input
                        mh-class="col-3"
                        field="ID"
                        :readonly="!edit"
                        :table="invoice.releveCompte"
                      ></mh-input>
                      <mh-input
                        mh-class="col-3"
                        field="date_creation"
                        :readonly="!edit"
                        :table="invoice.releveCompte"
                      ></mh-input>
                      <mh-input
                        mh-class="col-3"
                        field="creancier"
                        readonly
                        :table="invoice"
                      ></mh-input>
                      <mh-input
                        mh-class="col-3"
                        field="report"
                        :readonly="!edit"
                        :table="invoice.releveCompte"
                        append="€"
                      ></mh-input>
                      <mh-input
                        mh-class="col-3"
                        field="totalCreancier"
                        :readonly="!edit"
                        :table="invoice.releveCompte"
                        append="€"
                      ></mh-input>
                      <mh-input
                        mh-class="col-3"
                        field="totalChezNous"
                        :readonly="!edit"
                        :table="invoice.releveCompte"
                        append="€"
                      ></mh-input>
                      <mh-input
                        mh-class="col-3"
                        field="totalChezVous"
                        :readonly="!edit"
                        :table="invoice.releveCompte"
                        append="€"
                      ></mh-input>
                      <mh-input
                        mh-class="col-3"
                        field="balance"
                        :readonly="!edit"
                        :table="invoice.releveCompte"
                        append="€"
                      ></mh-input>
                      <mh-input
                        mh-class="col-3"
                        field="regularised"
                        :readonly="!edit"
                        :table="invoice.releveCompte"
                      ></mh-input>
                      <mh-input
                        mh-class="col-12"
                        field="note"
                        :readonly="!edit"
                        :table="invoice.releveCompte"
                        labelColsLg="1"
                      ></mh-input>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab :active="tab == 'Paiements'" title="Paiements">
              <AddInvoicesPayments
                :key="render"
                @modified="load()"
                :invoice_id="invoice.ID.value"
              ></AddInvoicesPayments>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
      <b-modal
        title="Envoyer la facture par mail"
        id="email-invoice"
        size="lg"
        title-class="text-center"
        hide-footer
      >
        <InvoiceMail
          @close="$bvModal.hide('email-invoice')"
          object="facture"
          :invoice_id="invoice.ID.value"
        ></InvoiceMail>
      </b-modal>
    </b-row>
  </div>
</template>

<script>
import invoices from "@/services/invoices.js";
import DateTime from "@/services/DateTime.js";
import InvoiceMail from "@/components/InvoiceMail";
import MhInput from "@/components/MhInput.vue";
import AddInvoicesPayments from "@/views/AddInvoicesPayments";
export default {
  name: "invoice-view",
  components: { MhInput, AddInvoicesPayments, InvoiceMail },
  props: {},
  data() {
    return {
      invoice: {},
      tab: "",
      add_payement: false,
      edit: true,
      render: 0,
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Factures",
          to: { name: "invoices" },
        },
      ],
      paymentsFields: [
        {
          key: "date",
          label: "Date",
          sortable: true,
        },
        {
          key: "compte",
          label: "Compte société",
          sortable: true,
        },
        {
          key: "compte_src",
          label: "Compte source",
          sortable: true,
        },
        {
          key: "note",
          label: "Note",
          sortable: false,
        },
        {
          key: "montant",
          label: "Montant",
          sortable: true,
          class: "text-right",
        },
      ],
      invoiceLinesFields: [
        {
          key: "description",
          label: "Description",
          sortable: true,
        },
        {
          key: "prix_unitaire",
          label: "Prix unitaire",
          class: "text-right",
          sortable: true,
        },
        {
          key: "unit",
          label: "Nombre d'unités",
          class: "text-right",
          sortable: true,
        },
        {
          key: "soustotal",
          label: "Sous-total",
          class: "text-right",
          sortable: true,
        },
        {
          key: "soustotalTVAC",
          label: "Sous-total TVAC",
          class: "text-right",
          formatter: (value, key, item) => {
            return (
              item.prix_unitaire *
              item.unit *
              (1 + parseFloat(this.invoice.tva.value / 100))
            );
          },
          sortable: true,
        },
      ],
      loaded: false,
    };
  },
  created() {
    if (this.$route.params.tab) {
      this.tab = this.$route.params.tab;
    }
    this.load();
  },
  computed: {
    account_statement_pdf() {
      return (
        this.$store.getters.url +
        "/account-statement/" +
        this.invoice.releveCompte.ID.value +
        "/pdf?token=" +
        encodeURIComponent(localStorage.getItem("vue-token"))
      );
    },
    pdf() {
      return (
        this.$store.getters.url +
        "/invoice/" +
        this.invoice.ID.value +
        "/pdf?token=" +
        encodeURIComponent(localStorage.getItem("vue-token"))
      );
    },
    invoiceLinesTotal() {
      return this.twoDigits(
        this.invoice.lignesFacture.reduce(
          (a, b) => a + parseFloat(b.prix_unitaire * b.unit),
          0
        )
      );
    },
    invoiceLinesTotalVTAC() {
      return this.twoDigits(
        this.invoice.lignesFacture.reduce(
          (a, b) =>
            a +
            parseFloat(
              b.prix_unitaire *
                b.unit *
                (1 + parseFloat(this.invoice.tva.value / 100))
            ),
          0
        )
      );
    },
    paymentsTotalVTAC() {
      return this.twoDigits(
        this.invoice.paiements.reduce((a, b) => a + b.montant, 0)
      );
    },
  },
  watch: {
    $route() {
      // react to route changes...
      this.items.pop();
      this.load();
    },
  },
  methods: {
    save() {
      invoices
        .update_invoice({
          invoice_id: this.$route.params.id,
          invoice: this.invoice,
        })
        .then(() => {
          this.$bvToast.toast("Facture mise à jour", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 2000,
            solid: false,
          });
          this.load(false);
          this.render++;
        });
    },
    load(addBread = true) {
      invoices.get(this.$route.params.id).then((response) => {
        this.loaded = true;
        this.invoice = response.data;
        if (!this.invoice.ID) {
          this.items.push({
            text: "Facture n° " + this.$route.params.id + " inexistante",

            active: true,
          });
          return;
        }
        //this.invoice.tva.value *= 100;
        this.invoice.prixTVAC.value = this.twoDigits(
          this.invoice.prixTVAC.value
        );
        if (addBread) {
          this.items.push({
            text:
              "Facture n° " +
              this.invoice.ID.value +
              " (" +
              this.invoice.type.i18n +
              ")",
            active: true,
          });
        }
      });
    },
    nl2br(str) {
      return str.replace(/\n/g, "<br/>");
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    twoDigits(value) {
      return Number(value).toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
.pre-formatted {
  white-space: pre;
}
</style>